import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { tokenManager } from '@/queries/token-manager';

type UserState = {
  userSession: boolean;
  loading: boolean;
};

export const checkToken = createAsyncThunk('user/checkToken', async () => {
  const accessToken = tokenManager.getAccessToken();
  return !!accessToken;
});

const initialState: UserState = {
  userSession: false,
  loading: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearSession: (state) => {
      state.userSession = false;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkToken.fulfilled, (state, action) => {
        const accessToken = action.payload;
        state.userSession = !!accessToken;
        state.loading = false;
      })
      .addCase(checkToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkToken.rejected, (state) => {
        state.userSession = false;
        state.loading = false;
      });
  },
});

export const { clearSession } = userSlice.actions;

export default userSlice.reducer;
